import React, { useState, useEffect, useMemo, useContext } from "react";
import { Row, Col, Tooltip, message } from "antd";
import { Link } from "react-router-dom";
import { PiHeartFill } from "react-icons/pi";
import { getCookie } from "../../helper/cookie";
import { UserContext } from "../../context/userContext";
import { getAllProductsByGender } from "../../services/womanProducts/womanProducts";
import { patchUserLike } from "../../services/user/user";
import { formatNumber } from "../../helper/fomartNum";
import { priceNew } from "../../helper/priceNew";
import Modal_No_Login from "../../components/Modal_No_Login";
import FilterWomanProducts from "../../components/FilterWomanProducts";
import "./WomanProducts.scss";

export let paramsFilterDefault = {
  q: "",
  page: 1,
  name: "",
  size: "",
  color: "",
  condition: "",
  priceSort: "",
};

const priceNewSafe = (price_old, sales) => {
  const p = Number(price_old) || 0;
  const s = Number(sales) || 0;
  return Math.round((p * (100 - s)) / 100);
};

function WomanProducts() {
  const [productsFull, setProductsFull] = useState([]);
  const [paramsFilterUser, setParamsFilterUser] = useState(paramsFilterDefault);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const token = getCookie("token");
  const { currentUser, setCurrentUser } = useContext(UserContext);

  // Fetch products gender "Woman"
  useEffect(() => {
    const fetchApi = async () => {
      const data = await getAllProductsByGender("Woman");
      setProductsFull(data || []);
    };
    fetchApi();
  }, []);

  // Filter & sort
  const productsFiltered = useMemo(() => {
    if (!productsFull || productsFull.length === 0) return [];

    return [...productsFull]
      .filter((p) => p.stock)
      .filter((p) =>
        paramsFilterUser.q
          ? p.name?.toLowerCase().includes(paramsFilterUser.q.toLowerCase()) ||
            p.color?.toLowerCase().includes(paramsFilterUser.q.toLowerCase()) ||
            p.condition
              ?.toLowerCase()
              .includes(paramsFilterUser.q.toLowerCase())
          : true
      )
      .filter((p) =>
        paramsFilterUser.name
          ? p.name?.toLowerCase() === paramsFilterUser.name.toLowerCase()
          : true
      )
      .filter((p) =>
        paramsFilterUser.size ? p.size === paramsFilterUser.size : true
      )
      .filter((p) =>
        paramsFilterUser.color
          ? p.color?.toLowerCase() === paramsFilterUser.color.toLowerCase()
          : true
      )
      .filter((p) =>
        paramsFilterUser.condition
          ? p.condition?.toLowerCase() ===
            paramsFilterUser.condition.toLowerCase()
          : true
      )
      .sort((a, b) => {
        const priceA = priceNewSafe(a.price_old, a.sales);
        const priceB = priceNewSafe(b.price_old, b.sales);
        if (paramsFilterUser.priceSort === "cao-den-thap")
          return priceB - priceA;
        if (paramsFilterUser.priceSort === "thap-den-cao")
          return priceA - priceB;
        return 0;
      });
  }, [productsFull, paramsFilterUser]);

  const getProductId = (p) => p.idProducts || p.id || p.key || p._id;
  const getLikedList = () =>
    Array.isArray(currentUser?.liked) ? currentUser.liked : [];
  const isProductLiked = (product) =>
    getLikedList().includes(getProductId(product));

  const handleActiveLove = async (product) => {
    if (!currentUser) return;
    const id = getProductId(product);
    const likedList = getLikedList();
    const isLiked = likedList.includes(id);
    const newLiked = isLiked
      ? likedList.filter((pid) => pid !== id)
      : [...likedList, id];
    try {
      await patchUserLike(currentUser.id, newLiked);
      setCurrentUser({ ...currentUser, liked: newLiked });
    } catch {
      messageApi.error("Không thể lưu trạng thái yêu thích");
    }
  };

  return (
    <div className="pf-sectionOne woman-products">
      {contextHolder}
      <div className="container">
        <div className="pf-sectionOne-wrapper">
          <FilterWomanProducts
            productsFull={productsFull}
            paramsFilterUser={paramsFilterUser}
            setParamsFilterUser={setParamsFilterUser}
          />
          <Row gutter={[20, 20]}>
            {productsFiltered.map((p, index) => {
              const productId = getProductId(p) || index;
              return (
                <Col
                  key={productId}
                  xxl={6}
                  xl={6}
                  lg={8}
                  md={12}
                  sm={12}
                  xs={24}
                >
                  <Link to={`/products/${productId}`}>
                    <div className="products-item">
                      <img src={p.thumbnail1} alt="thumb" className="img" />
                      <img
                        src={p.thumbnail2}
                        alt="thumb2"
                        className="img-abs"
                      />
                      <div className="products-item-name">{p.name}</div>
                      <div className="products-item-size">{p.size}</div>
                      <div className="products-item-sales">-{p.sales}%</div>
                      <div className="products-item-price">
                        <div className="price_new">
                          {formatNumber(priceNew(p.price_old, p.sales))}
                          <span className="underline">đ</span>
                        </div>
                        <del className="price_old">
                          {formatNumber(p.price_old)}
                          <span className="underline">đ</span>
                        </del>
                      </div>
                      <Tooltip title="Thích">
                        <PiHeartFill
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (!token) {
                              setIsModalOpen(true);
                              return;
                            }
                            handleActiveLove(p);
                          }}
                          className={`iconLove ${
                            isProductLiked(p) ? "active" : ""
                          }`}
                        />
                      </Tooltip>
                    </div>
                  </Link>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>

      <Modal_No_Login
        isModalOpen={isModalOpen}
        handleCancel={() => setIsModalOpen(false)}
      />
    </div>
  );
}

export default WomanProducts;
